module.exports = __webpack_public_path__ + "img/Aggregation_Hotspot.baa26d7e.png";